<template>
  <div class="toc"> 
    <div class="ui vertical inverted menu mysidebar">
      <div class="ui inline dropdown button" id="dd" style="color: black; margin: 10px; width: 80%">
        <div class="text">
          {{$auth.user().name}}
        </div>
        <i class="dropdown icon"></i>
        <div class="menu">
          <template v-if="clinics && clinics.length > 1 && $auth.check('doctor')"> 
            <div 
              class="item" 
              v-for="clinic in clinics" :key="clinic.id"
              @click="changeClinic(clinic)"
            >
              <i class="hospital icon" />
              {{ clinic.name }}
            </div>  
            <div class="ui divider" />
          </template>
          <div class="item" @click="navigateTo('User_Settings')">
            <i class="address book icon" />
            {{ $t('accountSettings') }}
          </div>
          <div class="item" @click="navigateTo('Clinic_Settings')" v-if="isAdmin()">
            <i class="cog icon" />
            {{ $t('clinicSettings') }}
          </div>
          <div class="ui divider" />
          <div class="item" @click="logout()">
            <i class="sign out alternate icon"></i>
            {{ $t('logout') }}
          </div>
        </div>
      </div>
      <div class="item" @click="navigateTo('Home')" style="cursor: pointer;">
        <a class="header">
          <i class="home icon"/>
          {{ $t('home')}}
        </a>
      </div>
      <div class="item" v-if="isAdmin()">
        <div class="header">
          <i class="doctor circle icon"/>
          Doctor
        </div>
        <div class="menu">
          <a class="item" @click="navigateTo('New_Doctor')">New doctor</a>
          <a class="item" @click="navigateTo('Doctors')">Doctors</a>
        </div>
      </div>
      <div class="item" v-if="isAdmin()">
        <div class="header">
          <i class="user circle icon"/>
          Employee
        </div>
        <div class="menu">
          <a class="item" @click="navigateTo('New_Employee')">New employee</a>
          <a class="item" @click="navigateTo('Employees')">Employees</a>
        </div>
      </div>
      <div class="item">
        <div class="header">
          <i class="users icon"/>
          Patient
        </div>
        <div class="menu">
          <a 
            class="item"
            v-if="$auth.check('employee') || isAdmin()"
            @click="
              navigateTo('Update_Patient', {
                key: 'params',
                value: {
                  id: 'new'
                }
              })
            "
          >
            New patient
          </a>
          <a class="item" @click="navigateTo('Patients')">Patients</a>
        </div>
      </div>
      <div class="item">
        <div class="header">
          <i class="folder open icon"/>
          Reservation
        </div>
        <div class="menu">
          <a class="item" @click="navigateTo('New_Reservation')" v-if="$auth.check('employee') || isAdmin()">New reservation</a>
          <a class="item" @click="navigateTo('Reservations')">Reservations</a>
        </div>
      </div>
      <div class="item" v-if="isAdmin()">
        <div class="header">
          <i class="weight icon"/>
          Medical Machine
        </div>
        <div class="menu">
          <a class="item" @click="navigateTo('New_Medical_Machines')">New medical machine</a>
          <a class="item" @click="navigateTo('Medical_Machines')">Medical machines</a>
        </div>
      </div>
      <div class="item" v-if="$auth.check('employee') || isAdmin()">
        <div class="header">
          <i class="money bill alternate outline icon"/>
          Transaction
        </div>
        <div class="menu">
          <a 
            class="item" 
            @click="navigateTo('New_Expense_Transaction')" 
            v-if="$auth.user().can_make_transaction"
          >
            New expense
          </a>
          <a 
            class="item" 
            @click="navigateTo('Transactions')"
          >
            Transactions
          </a>
          <a class="item" @click="navigateTo('Requests')" v-if="$auth.user().can_make_transaction">Change request</a>
          <a class="item" @click="navigateTo('Transaction_Audit_Report')">Transaction audit</a>
        </div>
      </div>
      <h2 class="ui header item" v-if="useInventory && ($auth.check('employee') || isAdmin())"> Inventory </h2>
      <div class="item" v-if="useInventory && ($auth.check('employee') || isAdmin())">
        <div class="header">
          <i class="dolly flatbed icon"/>
          Supplier
        </div>
        <div class="menu">
          <a class="item" @click="navigateTo('New_Supplier')">New supplier</a>
          <a class="item" @click="navigateTo('Suppliers')">Suppliers</a>
        </div>
      </div>
      <div class="item" v-if="useInventory && ($auth.check('employee') || isAdmin())">
        <div class="header">
          <i class="syringe icon"/>
          Item
        </div>
        <div class="menu">
          <a class="item" @click="navigateTo('New_Item')">New item</a>
          <a class="item" @click="navigateTo('Items')">Items</a>
          <a class="item" @click="navigateTo('Audit')">Audit</a>
        </div>
      </div>
      <div class="item" v-if="useInventory && ($auth.check('employee') || isAdmin())">
        <div class="header">
          <i class="dollar sign icon"/>
          Invoice
        </div>
        <div class="menu">
          <a class="item" @click="navigateTo('New_Purchased_Invoice')">New invoice</a>
          <a class="item" @click="navigateTo('Invoices')">Invoices</a>
        </div>
      </div>
      <h2 class="ui header item" v-if="useFinancial && isAdmin()"> Financial </h2>
      <div class="item" v-if="useFinancial && isAdmin()">
        <div class="header">
          <i class="calculator icon"/>
          Reports
        </div>
        <div class="menu">
          <a class="item" @click="navigateTo('Financial_Report')">Financial report</a>
          <a class="item" @click="navigateTo('Finalize_Visits_Financial')">Visits report</a>
        </div>
      </div>
    </div>    
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabs: {
        first: 'doctors',
        second: 'employees',
        third: 'patients',
        fourth: 'reservations',
        fifth: 'medicalMachines',
        sixth: 'transactions',
      },
      currentTab: 'employees'
    }
  },
  computed: {
    useFinancial() {
      return this.permissions.financial_permissions.used
    },
    useInventory() {
      return this.permissions.invetory_permissions.used
    }
  },
  mounted () {
    if (this.$auth.check('employee')) {
      this.saveToLocalStorage('clinicId', this.clinic.tenantable.id)
    } else {
      const clinicId = Number(this.getFromLocalStorage('clinicId'))
      const clinicIds = this.clinics.map(clinic => clinic.id);
      if (!clinicIds.includes(clinicId)) {
        this.saveToLocalStorage('clinicId', this.clinics[0].id)
      }
    }

    this.getSettings(this.getClinicId())
    
    this.$nextTick(() => {
      $('#dd').dropdown({
        onChange: function () {
          const defaultText = $('#dd').dropdown('get default text')
          $('#dd').dropdown('set text', defaultText)
        }
      })
    });
  },
  methods: {
    changeClinic(clinic) {
      this.saveToLocalStorage('clinicId', clinic.id)
      window.location.reload()
    }
  },
}
</script>

<style scoped>
  .toc {
    position: fixed;
    z-index: 1;
    background-color: #092442 !important;
    -webkit-box-flex: 0;
    -webkit-flex: 0 0 auto;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    top: 0;
    bottom: 0;
    left: 0;
  }
  .mysidebar {
    background-color: #092442 !important;
    /* color: #092442 !important; */
    /* f9fafe */
    max-height: 100vh;
    max-height: -webkit-fill-available;
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/layouts/SideBar.vue